import { render } from "./ApprovalLog.vue?vue&type=template&id=0f64f121"
import script from "./ApprovalLog.vue?vue&type=script&lang=js"
export * from "./ApprovalLog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Dev\\Personal\\reethi-inertia\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__